export type Volume = {
  number: number;
  title: string;
  headline: string;
  description?: string;
  listIntro: string;
  list: string[];
  afterList?: string;
  flow: string[];
  closing?: { lead: string; text: string };
};

export const volumes: Volume[] = [
  {
    number: 1,
    title: 'Tu auto desde cero',
    headline: 'Entendé tu vehículo aunque nunca hayas estudiado mecánica.',
    description: 'Aprendé a reconocer las partes principales del auto y qué función general cumple cada sistema.',
    listIntro: 'Incluye:',
    list: [
      'componentes principales',
      'qué hay debajo del capot',
      'tablero e indicadores',
      'aceite',
      'refrigerante',
      'líquido de frenos',
      'neumáticos',
      'batería',
      'luces',
      'visibilidad',
      'controles básicos',
    ],
    flow: ['Observar', 'Identificar', 'Revisar', 'Registrar'],
  },
  {
    number: 2,
    title: 'Mantenimiento preventivo total',
    headline: 'Qué revisar, cuándo hacerlo y cómo mantener tu auto bajo control.',
    description: 'Organizá el mantenimiento en lugar de acordarte solamente cuando aparece un problema.',
    listIntro: 'Incluye:',
    list: [
      'aceite y filtros',
      'refrigeración',
      'frenos',
      'neumáticos',
      'batería',
      'encendido',
      'correas y distribución',
      'suspensión',
      'dirección',
      'transmisión',
      'climatización',
      'sistema eléctrico',
      'escape',
      'GNC cuando corresponda',
    ],
    flow: ['Revisar', 'Organizar', 'Registrar', 'Prevenir'],
  },
  {
    number: 3,
    title: 'Detectá las fallas a tiempo',
    headline: 'Aprendé a reconocer las señales que te da tu auto.',
    listIntro: 'Entendé mejor qué información observar cuando aparece:',
    list: [
      'un ruido',
      'una vibración',
      'una pérdida',
      'humo',
      'un olor extraño',
      'un testigo',
      'dificultad para arrancar',
      'pérdida de potencia',
      'aumento de consumo',
      'cambios al frenar',
      'cambios en la dirección',
      'desgaste irregular de neumáticos',
    ],
    flow: ['Síntoma', 'Contexto', 'Observación', 'Nivel de atención'],
    closing: { lead: 'Porque:', text: 'Un síntoma no es un diagnóstico.' },
  },
  {
    number: 4,
    title: 'Emergencias del auto',
    headline: 'Qué hacer cuando aparece un problema inesperado.',
    listIntro: 'Una guía rápida para ayudarte a tomar mejores decisiones ante situaciones como:',
    list: [
      'rueda pinchada',
      'auto que no arranca',
      'batería descargada',
      'temperatura elevada',
      'testigos importantes',
      'pérdidas',
      'humo o vapor',
      'problemas de frenos',
      'problemas de dirección',
      'falta de combustible',
      'inconvenientes en ruta',
      'incidentes viales',
      'necesidad de asistencia',
    ],
    afterList: 'Siempre priorizando la seguridad.',
    flow: ['Proteger', 'Identificar', 'Evaluar', 'Actuar'],
  },
];